module.exports = __webpack_public_path__ + "img/notifications.09e4d957.svg";